(function() {
    'use strict';

    var app = angular.module('app');

    // Collect the routes
    app.constant('routes', getRoutes());

    // Configure the routes and route resolvers
    app.config(['$routeProvider', 'routes', '$locationProvider', routeConfigurator]);

    function routeConfigurator($routeProvider, routes, $locationProvider) {

        routes.forEach(function(r) {
            $routeProvider.when(r.url, r.config);
        });

        $routeProvider.otherwise({ redirectTo: '/' });
    }

    // Define the routes
    function getRoutes() {
        return [
            {
                url: '/login/',
                config: {
                    templateUrl: 'app/users/login.html',
                    access: { requiredAuthentication: false },
                    settings: {}
                }
            }, {
                url: '/pickpack/',
                config: {
                    templateUrl: 'app/pickpack/pickpack_list.html',
                    access: { requiredAuthentication: true },
                    title: 'Pick/Pack Slips',
                    settings: {}
                }
            }, {
                url: '/alerts/',
                config: {
                    templateUrl: 'app/alerts/alert_list.html',
                    access: { requiredAuthentication: true },
                    title: 'Alert Log',
                    settings: {}
                }
            }, {
                url: '/pickpack/dashboard',
                config: {
                    templateUrl: 'app/pickpack/pickpack_dashboard.html',
                    access: { requiredAuthentication: true },
                    title: 'Pick/Pack Dashboard',
                    settings: {}
                }
            }, {
                url: '/pickpack/pick/:pid',
                config: {
                    templateUrl: 'app/pickpack/pick_detail.html',
                    access: { requiredAuthentication: true },
                    title: 'Pick Slip',
                    settings: {}
                }
            }, {
                url: '/pickpack/pack/:pid',
                config: {
                    templateUrl: 'app/pickpack/pack_detail.html',
                    access: { requiredAuthentication: true },
                    title: 'Pack Slip',
                    settings: {}
                }
            }, {
                url: '/pickpack/packcc/:pid',
                config: {
                    templateUrl: 'app/pickpack/pack_cc_detail.html',
                    access: { requiredAuthentication: true },
                    title: 'Pack Slip',
                    settings: {}
                }
            },{
                url: '/pickpack/details/:pid',
                config: {
                    templateUrl: 'app/pickpack/pick_pack_items.html',
                    access: { requiredAuthentication: true },
                    title: 'Pack Slip',
                    settings: {}
                }
            }, {
                url: '/pickpack/label_test',
                config: {
                    templateUrl: 'app/pickpack/ship-label-test.html',
                    access: { requiredAuthentication: true },
                    title: 'label test',
                    settings: {}
                }
            },{
                url: '/pickpack/pick_list_defaults/',
                config: {
                    templateUrl: 'app/pickpack/pick_list_defaults.html',
                    access: { requiredAuthentication: true },
                    title: 'label test',
                    settings: {}
                }
            },{
                url: '/pickpack/skip_item_pack/',
                config: {
                    templateUrl: 'app/pickpack/skip_item_pack.html',
                    access: { requiredAuthentication: true },
                    title: 'label test',
                    settings: {}
                }
            },{
                url: '/products/dashboard/',
                config: {
                    title: 'Product Dashboard',
                    templateUrl: 'app/products/dashboard.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/products/',
                config: {
                    templateUrl: 'app/products/product_list.html',
                    access: { requiredAuthentication: true },
                    title: 'Product List',
                    settings: {}
                }
            }, {
                url: '/products/list/',
                config: {
                    templateUrl: 'app/products/list.html',
                    access: { requiredAuthentication: true },
                    title: 'Product List',
                    settings: {}
                }
            }, {
                url: '/product/:pid',
                config: {
                    templateUrl: 'app/products/product_detail.html',
                    access: { requiredAuthentication: true },
                    title: 'Product Detail',
                    settings: {}
                }
            }, {
                url: '/products/attributes_wizard/:pid?',
                config: {
                    templateUrl: 'app/products/edit_attributes_wizard.html',
                    access: { requiredAuthentication: true },
                    title: 'Product Attribute Wizard',
                    settings: {}
                }
            },{
                url: '/products/image_upload.html',
                config: {
                    templateUrl: 'app/products/image_upload.html',
                    access: { requiredAuthentication: true },
                    title: 'Product Image Upload',
                    settings: {}
                }
            },
            {
                url: '/users/',
                config: {
                    title: 'users',
                    templateUrl: 'app/users/user_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },
            {
                url: '/customers/',
                config: {
                    title: 'customers',
                    templateUrl: 'app/users/customers_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },
            {
                url: '/users_cf/',
                config: {
                    title: 'users',
                    templateUrl: 'app/users/user_list_cf.cfm',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/',
                config: {
                    title: 'homepage dashboard',
                    templateUrl: 'app/homepage/homepage.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/users/:uid',
                config: {
                    title: 'users detail',
                    templateUrl: 'app/users/user_detail.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/locations/',
                config: {
                    title: 'locations',
                    templateUrl: 'app/locations/locations.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/po/',
                config: {
                    title: 'Purchase Orders',
                    templateUrl: 'app/purchaseorders/po_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/purchaseorder/pending/',
                config: {
                    title: 'PO Pending Creation',
                    templateUrl: 'app/purchaseorders/pending_po_creation.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/po/:poid/:method',
                config: {
                    title: 'PO Details',
                    templateUrl: 'app/purchaseorders/po_details.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/purchaseorder/pick/:poid/',
                config: {
                    title: 'PO Pick Details',
                    templateUrl: 'app/purchaseorders/po_pick.html',
                    access: { requiredAuthentication: true },
                    settings: {
                    }
                }
            }, {
                url: '/orders/packages',
                config: {
                    title: 'orders',
                    templateUrl: 'app/orderpackages/orderpackage_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/orders2/',
                config: {
                    title: 'orders',
                    templateUrl: 'app/orders/order_list_2.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/orders/',
                config: {
                    title: 'orders',
                    templateUrl: 'app/orders/order_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/orderasinsearch/',
                config: {
                    title: 'orders',
                    //templateUrl: 'app/orderasinsearch/order_asin_list.html',
                    templateUrl: '/tasks/orders/order_asin_search.cfm',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/order/:oid',
                config: {
                    title: 'orders',
                    templateUrl: 'app/orders/order_detail.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/orders/open_items',
                config: {
                    title: 'orders',
                    templateUrl: 'app/orders/open_items.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },  {
                url: '/reports/read_S3/',
                config: {
                    title: 'Read S3 File',
                    templateUrl: 'app/reports/read_s3_file.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/orders/endicia/',
                config: {
                    title: 'Tasks report',
                    templateUrl: 'app/orders/endicia.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/asin_check.html',
                config: {
                    title: 'Tasks report',
                    templateUrl: 'app/reports/mws_inventory_check.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/walmart_reprice_report.html',
                config: {
                    title: 'Walmart Reprice Report',
                    templateUrl: 'app/reports/walmart_reprice_report.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/amazon_reprice_report.html',
                config: {
                    title: 'Amazon Reprice Report',
                    templateUrl: 'app/reports/amazon_reprice_report.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/quality_control.html',
                config: {
                    title: 'Quality Control',
                    templateUrl: 'app/reports/quality_control.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/invalid-address.html',
                config: {
                    title: 'invalid address report',
                    templateUrl: 'app/reports/invalid_address.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/tasks/',
                config: {
                    title: 'Tasks report',
                    templateUrl: 'app/reports/task_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/reports/prices',
                config: {
                    title: 'Price Report',
                    templateUrl: 'app/reports/price_report.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/review_phantoms',
                config: {
                    title: 'review_phantoms report',
                    templateUrl: 'app/reports/review_phantoms.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/reports/order_fulfillment.html',
                config: {
                    title: 'order fulfillment report',
                    templateUrl: 'app/reports/report_order_fulfillment.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/amazon_errors/',
                config: {
                    title: 'Amazon Errors',
                    templateUrl: 'app/reports/amazon_errors.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/data_file/:type/:data_id',
                config: {
                    title: 'View Data File',
                    templateUrl: 'app/reports/view_data_file.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/shipping/critical_shipment_report/',
                config: {
                    title: 'critical_shipment_report',
                    templateUrl: 'app/reports/critical_shipment_report.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/shipping/special_handling_report/',
                config: {
                    title: 'special handling report',
                    templateUrl: 'app/reports/special_handling_report.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/stores/',
                config: {
                    title: 'Store List',
                    templateUrl: 'app/stores/store_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/store/:sid',
                config: {
                    title: 'Store Detail',
                    templateUrl: 'app/stores/store_detail.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/stores/products',
                config: {
                    title: 'Store Product List',
                    templateUrl: 'app/storeproducts/store_product_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/stores/product/:spid',
                config: {
                    title: 'Store Product Detail',
                    templateUrl: 'app/storeproducts/store_product_detail.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/reports/products/velocity',
                config: {
                    title: 'Product Velocity',
                    templateUrl: 'app/reports/velocity.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },

            {
                url: '/reports/orders/sales',
                config: {
                    title: 'Sales',
                    templateUrl: 'app/reports/sales_report.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },
            {
                url: '/vendors/',
                config: {
                    title: 'Vendor List',
                    templateUrl: 'app/vendors/vendor_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },
            {
                url: '/manufacturers/',
                config: {
                    title: 'Manufacturers List',
                    templateUrl: 'app/vendors/manufacturer_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },
            {
                url: '/vendors/:vid',
                config: {
                    title: 'Vendor Detail',
                    templateUrl: 'app/vendors/vendor_detail.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },

            {
                url: '/vendor/inventory/',
                config: {
                    title: 'Vendor Inventory Check',
                    templateUrl: 'app/vendors/inventory_check.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },

            {
                url: '/vendor/products/',
                config: {
                    title: 'Vendor Product List',
                    templateUrl: 'app/vendorproducts/vendor_product_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/vendor/product/:vpid',
                config: {
                    title: 'Vendor Product Detail',
                    templateUrl: 'app/vendorproducts/vendor_product_detail.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/vendor/import_products/:vid',
                config: {
                    title: 'Vendor Import Products',
                    templateUrl: 'app/vendorproducts/import_vendor_products.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/vendor/analyze_fill/',
                config: {
                    title: 'Vendor Product Detail',
                    templateUrl: 'app/vendorproducts/vendor_analyze_fill.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/bol/',
                config: {
                    title: 'Bill Of Lading',
                    templateUrl: 'app/bol/bol_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/competitor/phantomapproval',
                config: {
                    title: 'Phantom Approval',
                    templateUrl: 'app/competitorproducts/phantom_approval.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/competitor/summary',
                config: {
                    title: 'Competitor Summary',
                    templateUrl: 'app/competitorproducts/competitor_summary.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },
            {
                url: '/parents/',
                config: {
                    title: 'Parent List',
                    templateUrl: 'app/productparents/list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/parent/:parent_id',
                config: {
                    title: 'Parent Details',
                    templateUrl: 'app/productparents/detail.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/stores/products/history/:spid',
                config: {
                    title: 'Price History',
                    templateUrl: 'app/storeproducts/reprice_details.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }, {
                url: '/stores/products/whistory/:spid',
                config: {
                    title: 'Price History',
                    templateUrl: 'app/storeproducts/reprice_wal_details.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/getty/',
                config: {
                    title: 'Getty',
                    templateUrl: 'app/getty/list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/receiving/',
                config: {
                    title: 'Receiving',
                    templateUrl: 'app/receiving/list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/gettyimages/',
                config: {
                    title: 'Getty',
                    templateUrl: 'app/getty/list_report.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/productcategories/',
                config: {
                    title: 'Product Categories',
                    templateUrl: 'app/products/category_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/contenttheme/',
                config: {
                    title: 'Content Themes',
                    templateUrl: 'app/products/content_theme.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/stock/',
                config: {
                    title: 'Stock',
                    templateUrl: 'app/stock/list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/products/ps/',
                config: {
                    title: 'Product Source',
                    templateUrl: 'app/products/product_source_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/messages/',
                config: {
                    title: 'Messages',
                    templateUrl: 'app/messages/list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/allpods/',
                config: {
                    title: 'UNPRINTED POD PICKLIST ITEMS',
                    templateUrl: 'app/allpods/list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/podorders/:pid',
                config: {
                    title: 'NOT PICKED/PRINTED ORDERS',
                    templateUrl: 'app/allpods/orders_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            },{
                url: '/podorders/',
                config: {
                    title: 'NOT PICKED/PRINTED ORDERS',
                    templateUrl: 'app/allpods/orders_list.html',
                    access: { requiredAuthentication: true },
                    settings: {}
                }
            }
        ];
    }
})();
